import { render, staticRenderFns } from "./ketentuan.vue?vue&type=template&id=9dac3c54&"
import script from "./ketentuan.vue?vue&type=script&lang=js&"
export * from "./ketentuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports